import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import AssetsHeaderWithCount from '../AssetsLabelCount';
import BackNextButtonContainer from '../BackNextButtonContainer';
import CreateJiraTicket from './CreateJiraTicket';
import TabHeader from '../../common/TabHeader';
import ProductSearchWrapper from '../../Product/ProductSearchWrapper';
import * as assetsAction from '../../../redux/actions/assetsAction';

//constants
const title = 'Review & Create';
const explanation =
	'Listed below are the assets that will be created along with their files, and any other details. Corgis checks for duplicate asset entries and if there are any issues it will be flagged in the table below. When everything looks good and there are no other edits left to make, click the Create button below to add these assets into Corgis.';
const actions = [<CreateJiraTicket />];

const useStyles = makeStyles((theme) => ({
	displayInlineBlock: { display: 'inline-block' },
	productSearchContainer: {
		width: '35em',
	},
}));

const RenderAsset = (asset) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { product } = asset;
	// handle product search element on value change.
	const productSearchOnValueChange = (selectedProductObj) => {
		dispatch(assetsAction.linkProductToAsset(asset, selectedProductObj));
	};
	const onInputChange = (value) => {
		dispatch(assetsAction.unlinkProductFromAsset(asset));
	};
	// product search components props
	const productSearchProps = {
		onValChange: productSearchOnValueChange,
		onInputChange: onInputChange,
		asset,
		product,
	};
	return (
		<Grid container key={asset.id}>
			<Grid item xs={12}>
				<Divider />
				<Box pt={2} />
			</Grid>
			<Grid container>
				<Typography variant="body1" className={classes.displayInlineBlock}>
					{asset.name}
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<Grid container>
					<Typography>Product</Typography>
				</Grid>
				<Grid container className={classes.productSearchContainer}>
					<ProductSearchWrapper {...productSearchProps} />
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Box pt={2} />
				<Divider />
			</Grid>
		</Grid>
	);
};

const ReviewAndSubmitAsset = () => {
	const assets = useSelector((state) => state.assets);
	return (
		<Grid container direction="column" spacing={3}>
			<Grid item>
				<TabHeader
					title={title}
					explanation={explanation}
					explanationDataCy="review-submit-info-txt"
					actions={actions}
				/>
			</Grid>
			<Grid item>
				<BackNextButtonContainer />
			</Grid>
			<Grid item>
				<AssetsHeaderWithCount />
			</Grid>
			<Grid item>
				{assets.map((asset) => {
					return (
						<Grid container key={asset.id}>
							<RenderAsset {...asset} />
						</Grid>
					);
				})}
			</Grid>
		</Grid>
	);
};

export default ReviewAndSubmitAsset;
